<template>
    <div class="modal-text">
        <p>
            Le mode enseignant va vous permettre de créer un projet avec vos élèves, répartis ou non en sous-groupes.
            Ils pourront travailler <b>en autonomie</b>, <b>simultanément entre eux</b>, tout en se basant sur un <b>code "modèle"</b> que vous pourrez modifier.
        </p>

        <br>

        <p>
            Chaque sous-groupe d'élèves aura accès à une interface composée de :
        </p>

        <ul class="list-disc list-inside">
            <li class="my-1">
                un fichier de structure de page en HTML
            </li>
            <li class="my-1">
                un fichier de style en CSS
            </li>
            <li class="my-1">
                un fichier de script en JavaScript
            </li>
            <li class="my-1">
                un espace de prévisualisation
            </li>
        </ul>

        <br>

        <p>
            Ces fichiers pourront être modifiés par les élèves composant le sous-groupe.
            Si vous souhaitez organiser des <b>exercices individuels</b>, il vous est possible de créer des sous-groupes composés d'un seul élève.
        </p>

        <br>

        <p>
            Le mode enseignant propose également <b>un mode examen</b>, qui permet de verrouiller l’édition du code à partir d’une date donnée dans le cadre des exercices notés.
            Pour cela, il vous suffira de renseigner une <b>date de début et de fin</b> lors de la création de votre projet.
        </p>

        <br>

        <p>
            Lorsque la date de fin est atteinte, le projet sera <b>toujours accessible en lecture seule</b> pour les participants mais ils ne pourront plus éditer le code.
        </p>

        <br>

        <p>
            Le <b>code modèle</b> vous permettra de donner une base solide à vos élèves pour les aider dans la réalisation de vos exercices.
            Pour gérer le code modèle, il vous suffit d'éditer le code dans votre dossier enseignant et d'appuyer sur le bouton "Mettre à jour".
            Après confirmation, votre code sera transféré sur tous les sous-groupes et <b>permettra à vos étudiants de récupérer votre code.</b>
        </p>


        <hr class="my-5" />

        <h3>Liens utiles</h3>

        <ul class="list-disc list-inside">
            <li class="my-1">
                <router-link class="link" :to="{ name: 'Create Project' }">
                <span>Créer un nouveau projet</span>
                </router-link>
            </li>
            <li class="my-1">
                <router-link class="link" :to="{ name: 'Dashboard' }">
                <span>Retrouves mes projets</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "ConnectionDialogContent"
}
</script>
